import React from 'react';

interface CoinIconProps {
  size?: number;
  primaryColor?: string;
  secondaryColor?: string;
  accentColor?: string;
  altColor?: string;
  className?: string;
}

export const CoinIcon: React.FC<CoinIconProps> = ({
  size = 32,
  primaryColor = '#FFC300', // Bright yellow
  secondaryColor = '#FFE066', // Light yellow
  accentColor = '#FF9800', // Orange
  altColor = '#FFB347', // Muted orange (alternating quarters)
  className = ''
}) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 512 512"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
    aria-hidden="true"
  >
    {/* Full outer circle - base layer */}
    <circle cx="256" cy="256" r="256" fill={accentColor} />

    {/* Segmented pattern using circle sectors */}
    {/* Top-left quarter */}
    <path d="M 256 256 L 256 0 A 256 256 0 0 1 256 256 Z" 
          fill={primaryColor} 
          transform="rotate(-45 256 256)" />
    
    {/* Top-right quarter */}
    <path d="M 256 256 L 256 0 A 256 256 0 0 1 512 256 Z" 
          fill={altColor}
          transform="rotate(45 256 256)" />
    
    {/* Bottom-right quarter */}
    <path d="M 256 256 L 512 256 A 256 256 0 0 1 256 256 Z" 
          fill={primaryColor} 
          transform="rotate(45 256 256)" />
    
    {/* Bottom-left quarter */}
    <path d="M 256 256 L 256 512 A 256 256 0 0 1 0 256 Z" 
          fill={altColor}
          transform="rotate(45 256 256)" />

    {/* Middle ring - yellow */}
    <circle cx="256" cy="256" r="192" fill={secondaryColor} />

    {/* Inner circle - lighter yellow */}
    <circle cx="256" cy="256" r="160" fill={secondaryColor} opacity="0.8" />

    {/* Star in center */}
    <path
      d="M 256,176 
         L 279.5,231.3 
         L 338.3,231.3 
         L 291.4,268.4 
         L 314.9,323.7 
         L 256,286.6 
         L 197.1,323.7 
         L 220.6,268.4 
         L 173.7,231.3 
         L 232.5,231.3 Z"
      fill={accentColor}
    />

    {/* Shine effect - top left */}
    <ellipse cx="180" cy="150" rx="60" ry="40" fill="#FFFFFF" opacity="0.3" />
    <ellipse cx="170" cy="140" rx="30" ry="20" fill="#FFFFFF" opacity="0.4" />
  </svg>
);

// Green variant of CoinIcon used for Soko Points (gambling balance), to visually
// distinguish it from Kick Points, which uses CoinIcon's default gold colors.
export const SokoCoinIcon: React.FC<Pick<CoinIconProps, 'size' | 'className'>> = ({ size, className }) => (
  <CoinIcon
    size={size}
    className={className}
    primaryColor="#22C55E"
    secondaryColor="#86EFAC"
    accentColor="#15803D"
    altColor="#16A34A"
  />
);